<script setup>
import { user_image } from '@/helpers'
import SupporterBadge from '../Supporters/SupporterBadge.vue'

defineProps({
  user: Object,
  small: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div class="relative shrink-0" :class="small ? 'size-8 sm:size-10' : 'size-20'">
    <img
      :src="user_image(user.image)"
      :alt="user.name + ' avatar'"
      :class="[small ? 'size-8 rounded-full sm:size-10' : 'size-20 shrink-0 rounded-lg']"
    />
    <div
      v-if="!!user.supporter"
      class="absolute"
      :class="[small ? '-bottom-1 -right-1 size-6' : '-bottom-2 -right-2']"
    >
      <div>
        <SupporterBadge
          :class="{
            'size-6': small,
            'size-8': !small,
          }"
        />
      </div>
    </div>
  </div>
</template>
